// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3_dDo","question":"Question_question__1-Y8T","description":"Question_description__qd3t_"};